import React, { createContext, useContext, useState, ReactNode } from 'react';

interface MarketplaceSearchContextType {
  q: string;
  setQ: (value: string | ((prev: string) => string)) => void;
  reload: () => void;
}

const MarketplaceSearchContext = createContext<MarketplaceSearchContextType | undefined>(undefined);

interface MarketplaceSearchProviderProps {
  children: ReactNode;
}

export const MarketplaceSearchProvider: React.FC<MarketplaceSearchProviderProps> = ({ children }) => {
  const [q, setQState] = useState('');

  const setQ = (value: string | ((prev: string) => string)) => {
    if (typeof value === 'function') {
      setQState(prev => value(prev));
    } else {
      setQState(value);
    }
  };

  const reload = () => {
    const u = new URL(window.location.href);
    u.searchParams.set('cache', Date.now().toString());
    window.history.replaceState({}, '', u.toString());
    setQ(v => v); // retrigger
  };

  return (
    <MarketplaceSearchContext.Provider value={{ q, setQ, reload }}>
      {children}
    </MarketplaceSearchContext.Provider>
  );
};

export const useMarketplaceSearch = () => {
  const context = useContext(MarketplaceSearchContext);
  if (context === undefined) {
    throw new Error('useMarketplaceSearch must be used within a MarketplaceSearchProvider');
  }
  return context;
};